import React from "react";
import { NavLink } from "react-router-dom";

const Navbar = () => {
  return (
    <header className="header-style1 menu_area-light">
      <div className="navbar-default border-bottom border-color-light-white">
        <div className="container-fluid px-lg-1-6 px-xl-2-5 px-xxl-2-9">
          <div className="row align-items-center">
            <div className="col-12 col-lg-12">
              <div className="menu_area alt-font">
                <nav className="navbar navbar-expand-lg navbar-light p-0">
                  <div className="navbar-header navbar-header-custom">
                    <NavLink to="/" className="navbar-brand">
                      <img
                        id="logo"
                        src="/img/logos/logo-inner.png"
                        alt="logo"
                      />
                    </NavLink>
                  </div>

                  <div className="navbar-toggler bg-primary"></div>

                  <ul className="navbar-nav ms-auto" id="nav">
                    <li>
                      <NavLink
                        to="/"
                        className={({ isActive }) =>
                          isActive ? "active-link" : ""
                        }
                      >
                        Home
                      </NavLink>
                    </li>
                    <li className="has-sub">
                      <a href="#">About us</a>
                    <ul className="sub-menu">
                        <li>
                          <NavLink
                            to="/who-we-are"
                            className={({ isActive }) =>
                              isActive ? "active-link" : ""
                            }
                          >
                            Who we are
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            to="/our-campus"
                            className={({ isActive }) =>
                              isActive ? "active-link" : ""
                            }
                          >
                            Our Campus
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            to="/reports-media"
                            className={({ isActive }) =>
                              isActive ? "active-link" : ""
                            }
                          >
                            Reports & Media
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            to="/foundational-philosophy"
                            className={({ isActive }) =>
                              isActive ? "active-link" : ""
                            }
                          >
                            Foundational Philosophy
                          </NavLink>
                        </li>
                      </ul>
                    </li>
                    <li className="has-sub">
                      <a href="#">Our Work</a>
                    <ul className="sub-menu">
                        <li>
                          <NavLink
                            to="/skill-development"
                            className={({ isActive }) =>
                              isActive ? "active-link" : ""
                            }
                          >
                            Skill Development
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            to="/education"
                            className={({ isActive }) =>
                              isActive ? "active-link" : ""
                            }
                          >
                            Education
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            to="/health"
                            className={({ isActive }) =>
                              isActive ? "active-link" : ""
                            }
                          >
                            Health
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            to="/abled"
                            className={({ isActive }) =>
                              isActive ? "active-link" : ""
                            }
                          >
                            Inclusion of Differently Abled
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            to="/sports"
                            className={({ isActive }) =>
                              isActive ? "active-link" : ""
                            }
                          >
                            Sports
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            to="/community-initiatives"
                            className={({ isActive }) =>
                              isActive ? "active-link" : ""
                            }
                          >
                            Community Initiatives
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            to="/livelihoods"
                            className={({ isActive }) =>
                              isActive ? "active-link" : ""
                            }
                          >
                            Livelihoods
                          </NavLink>
                        </li>
                      </ul>
                    </li>
                    <li className="has-sub">
                      <a href="#">Recent Updates</a>
                    <ul className="sub-menu">
                        <li>
                          <NavLink
                            to="/projects"
                            className={({ isActive }) =>
                              isActive ? "active-link" : ""
                            }
                          >
                            Our Initiatives
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            to="/events"
                            className={({ isActive }) =>
                              isActive ? "active-link" : ""
                            }
                          >
                            Events & Celebrations
                          </NavLink>
                        </li>
                      </ul>
                    </li>
                    <li>
                      <NavLink
                        to="/partner"
                        className={({ isActive }) =>
                          isActive ? "active-link" : ""
                        }
                      >
                        Partners
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        to="/gallery"
                        className={({ isActive }) =>
                          isActive ? "active-link" : ""
                        }
                      >
                        Gallery
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        to="/contact"
                        className={({ isActive }) =>
                          isActive ? "active-link" : ""
                        }
                      >
                        Contact
                      </NavLink>
                    </li>
                    <li className="d-xl-none">
                      <a
                        href="http://project.shamayitamath.in/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Project
                      </a>
                    </li>

                    <li className="d-xl-none">
                      <NavLink
                        to="/donate"
                        className={({ isActive }) =>
                          isActive ? "active-link" : ""
                        }
                      >
                        Donate
                      </NavLink>
                    </li>
                  </ul>
                  
                 <div className="attr-nav align-items-xl-center ms-xl-auto main-font">
                  <ul>
                    <li className="d-none d-xl-inline-block">
                      <a 
                        href="http://project.shamayitamath.in/" 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        className="btn-style3 medium text-white"
                      >
                        PROJECT
                      </a>
                    </li>
                  </ul>
                </div>

                  <div className="attr-nav align-items-xl-center ms-xl-auto main-font">
                    <ul>
                      <li className="d-none d-xl-inline-block">
                        <NavLink
                          to="/donate"
                          className={({ isActive }) =>
                            isActive
                              ? "btn-style3 medium text-white active-link"
                              : "btn-style3 medium text-white"
                          }
                        >
                          Donate
                        </NavLink>
                      </li>
                    </ul>
                  </div>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
